// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"DailyReportSummaryTable_totalRow_XoJ5B"};